import { render, staticRenderFns } from "./FileGrid.vue?vue&type=template&id=35abe8ba"
import script from "./FileGrid.vue?vue&type=script&lang=js"
export * from "./FileGrid.vue?vue&type=script&lang=js"
import style0 from "./FileGrid.vue?vue&type=style&index=0&id=35abe8ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports